import { ref } from 'vue';
import { Gateway } from '@/entities/gateway';

export const useGatewayRecord = () => ref<Gateway>({
  title: '',
  entityItem: null,
});
